<template>
  <div class="container-fluid py-4">
    <div class="row">
      <!-- STATS CARD 1: Total Templates -->
      <div class="col-xl-3 col-sm-6 col-12 mb-4">
        <div class="card">
          <div class="card-body p-3">
            <div class="row">
              <div class="col-8">
                <div class="numbers">
                  <p class="text-sm mb-0 text-uppercase font-weight-bold">Total Templates</p>
                  <h5 class="font-weight-bolder text-primary">{{ broadcasts.length }}</h5>
                </div>
              </div>
              <div class="col-4 text-end">
                <div class="icon icon-shape bg-gradient-primary shadow-primary text-center rounded-circle">
                  <i class="ni ni-folder-17 text-lg opacity-10" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- STATS CARD 2: DEVICE DETAILS -->
      <div class="col-xl-3 col-sm-6 col-12 mb-4">
        <div class="card shadow-sm border-0" @click="openDevicePlaylistModal" style="cursor: pointer;">
          <div class="card-body p-3">
            <div class="row align-items-center">
              <div class="col-8">
                <div class="numbers">
                  <p class="text-sm mb-0 text-uppercase font-weight-bold text-info">Network Status</p>
                  <h5 class="font-weight-bolder text-info">Device Details</h5>
                </div>
              </div>
              <div class="col-4 text-end">
                <div class="icon icon-shape bg-gradient-info shadow-info text-center rounded-circle">
                  <i class="fas fa-desktop text-lg opacity-10" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- STATS CARD 3: BROADCAST LIVE / QUICK VIEW -->
      <div class="col-xl-3 col-sm-6 col-12 mb-4">
        <div class="card shadow-sm border-0" :class="{'bg-gradient-success': isGlobalLive}">
          <div class="card-body p-3">
            <div class="row align-items-center">
              <div class="col-8">
                <div class="numbers">
                  <p class="text-sm mb-0 text-uppercase font-weight-bold" :class="isGlobalLive ? 'text-white' : 'text-success'">
                    {{ isGlobalLive ? 'Broadcast Live' : 'Quick View' }}
                  </p>
                  <button class="btn btn-sm mt-2 mb-0" :class="isGlobalLive ? 'btn-white' : 'bg-gradient-success'" @click="showSelectedModal = true">
                    <i class="fas fa-play me-2"></i> Selected ({{ selectedVideosCount }})
                  </button>
                </div>
              </div>
              <div class="col-4 text-end">
                <div 
                  class="icon icon-shape shadow-success text-center rounded-circle cursor-pointer"
                  :class="isGlobalLive ? 'bg-white text-success pulse-red' : 'bg-gradient-success text-white'"
                  @click="showSelectedModal = true"
                  style="cursor: pointer;"
                  title="Trigger Emergency for Selected Items"
                >
                  <i class="fas fa-play text-lg opacity-10" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- STATS CARD 4: STOP EMERGENCY CARD -->
      <div class="col-xl-3 col-sm-6 col-12 mb-4">
        <div class="card shadow-sm border-0" @click="stopAllEmergency" style="cursor: pointer;">
          <div class="card-body p-3">
            <div class="row align-items-center">
              <div class="col-8">
                <div class="numbers">
                  <p class="text-sm mb-0 text-uppercase font-weight-bold text-danger">Emergency Control</p>
                  <h5 class="font-weight-bolder text-danger">STOP ALL</h5>
                </div>
              </div>
              <div class="col-4 text-end">
                <div class="icon icon-shape bg-gradient-danger shadow-danger text-center rounded-circle">
                  <i class="fas fa-stop text-lg opacity-10" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pb-0 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
            <h6 class="mb-0">Emergency Alert Library</h6>
            <div class="d-flex flex-wrap gap-2 w-100 w-md-auto">
              <button class="btn btn-sm btn-outline-danger mb-0 flex-grow-1" @click="openTrashModal">
                <i class="fas fa-history me-2"></i> Audit / Trash Bin
              </button>
              <button class="btn btn-sm btn-outline-primary mb-0 flex-grow-1" @click="openMediaGallery">
                <i class="fas fa-images me-2"></i> Gallery
              </button>
              <button class="btn btn-sm bg-gradient-dark mb-0 flex-grow-1" @click="openAddModal">
                <i class="fas fa-plus me-2"></i> Create Template
              </button>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-4">Select</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Template Details</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Type</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Status</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Target Branches</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Target Devices</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Media</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Audit & Update History</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in paginatedBroadcasts" :key="item.emergency_id" :class="{'bg-light-danger': item.is_live, 'border-orphaned': isOrphaned(item)}">
                    <td class="ps-4">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" 
                               :checked="isGallerySelected(item.emergency_id)" 
                               @change="toggleItemSelection(item.emergency_id)">
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-3 py-1">
                        <div class="d-flex flex-column justify-content-center">
                         <h6 class="mb-0 text-sm text-dark">
                            {{ item.title }}
                            <span v-if="item.is_live" class="badge bg-danger ms-2 pulse-red-small">LIVE</span>
                            <span v-if="isOrphaned(item)" class="badge bg-danger ms-2">UNASSIGNED</span>
                          </h6>
                          <p class="text-xs text-secondary mb-0 text-truncate" style="max-width: 200px;">{{ item.message || 'No text message' }}</p>
                          <div v-if="item.active_from || item.active_to" class="text-xxs text-info mt-1">
                            <i class="fas fa-clock me-1"></i>
                            <span v-if="item.active_from">From: {{ formatDate(item.active_from) }}</span>
                            <span v-if="item.active_to" class="ms-1">Till: {{ formatDate(item.active_to) }}</span>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span class="badge badge-sm" :class="getTypeClass(item.type)">{{ item.type }}</span>
                      <div v-if="item.type === 'image'" class="text-xxs text-muted mt-1">
                        <i class="fas fa-clock me-1"></i>{{ item.display_time || 10 }}s
                      </div>
                      <div v-if="item.type === 'playlist' || item.type === 'playlist_link'" class="text-xxs text-muted mt-1">
                        <i class="fas fa-list me-1"></i>{{ ensureArray(item.playlist_items).length }} items
                      </div>
                    </td>
                    <td>
                      <span class="badge badge-sm" :class="item.status === 'active' ? 'bg-gradient-success' : 'bg-gradient-secondary'">
                        {{ item.status || 'inactive' }}
                      </span>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">{{ getMappedNames(item.branch_ids, branches, 'branch_name') }}</p>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">{{ getMappedNames(item.device_ids, devices, 'device_name') }}</p>
                    </td>
                    <td>
                      <span v-if="item.media_url" class="text-xs font-weight-bold text-primary" style="cursor:pointer" @click="viewMedia(item.media_url)">
                        <i class="fas fa-paperclip me-1"></i> View File
                      </span>
                      <span v-else-if="(item.type === 'playlist' || item.type === 'playlist_link') && ensureArray(item.playlist_items).length > 0" 
                            class="text-xs text-info font-weight-bold" style="cursor:pointer" @click="viewMedia(ensureArray(item.playlist_items)[0].media_url)">
                        <i class="fas fa-list me-1"></i> View Playlist
                      </span>
                      <span v-else class="text-xs text-secondary">None</span>
                    </td>

                    <!-- AUDIT & UPDATE HISTORY COLUMN -->
                    <td>
                      <div class="text-xxs text-dark">
                        <div><strong class="text-secondary">Created:</strong> {{ item.creator?.name || 'System' }}</div>
                        <div class="text-muted mb-1">{{ formatDate(item.created_at) }}</div>

                        <div v-if="item.updater" class="mt-1 pt-1 border-top">
                          <strong class="text-info">Updated:</strong> {{ item.updater?.name }}
                          <div class="text-muted">{{ formatDate(item.updated_at) }}</div>
                        </div>

                        <!-- BUTTON TO OPEN COMPLETE RECORD UPDATE HISTORY -->
                        <button class="btn btn-xs btn-outline-info mt-2 mb-0 w-100" @click="openHistoryModal(item)">
                          <i class="fas fa-history me-1"></i> History ({{ ensureArray(item.update_history).slice(0, 5).length }})
                        </button>
                      </div>
                    </td>

                    <td class="align-middle text-center">
                      <div class="d-flex justify-content-center align-items-center">
                        <button v-if="item.is_live" @click="stopSingleEmergency(item)" class="btn btn-sm btn-icon-only bg-gradient-danger rounded-circle me-2" title="Stop This Broadcast">
                          <i class="fas fa-stop"></i>
                        </button>
                        <button v-else @click="triggerSingleEmergency(item)" class="btn btn-sm btn-icon-only bg-gradient-warning rounded-circle me-2" title="Broadcast Now">
                          <i class="fas fa-bolt"></i>
                        </button>
                        <button @click="openEditModal(item)" class="btn btn-link text-info font-weight-bold text-xs mb-0">
                          <i class="fas fa-edit"></i>
                        </button>
                        <button @click="deleteTemplate(item.emergency_id)" class="btn btn-link text-danger font-weight-bold text-xs mb-0">
                          <i class="fas fa-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- PAGINATION FOOTER -->
          <div class="card-footer py-3">
            <div class="d-flex flex-column flex-sm-row justify-content-between align-items-center gap-3 text-center">
              <p class="text-sm text-secondary mb-0">
                Showing {{ paginatedBroadcasts.length }} of {{ broadcasts.length }} templates
              </p>
              <nav v-if="totalPages > 1">
                <ul class="pagination pagination-primary mb-0 flex-wrap justify-content-center">
                  <li class="page-item" :class="{ disabled: currentPage === 1 }">
                    <a class="page-link" href="javascript:;" @click="changePage(currentPage - 1)">
                      <i class="fa fa-angle-left"></i>
                    </a>
                  </li>
                  <li v-for="page in totalPages" :key="page" class="page-item" :class="{ active: currentPage === page }">
                    <a class="page-link" href="javascript:;" @click="changePage(page)">{{ page }}</a>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                    <a class="page-link" href="javascript:;" @click="changePage(currentPage + 1)">
                      <i class="fa fa-angle-right"></i>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL: UPDATE HISTORY TIMELINE (WHO UPDATED WHAT & WHEN) -->
    <div v-if="showRecordHistoryModal" class="modal-overlay p-2 p-md-0">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content border-0 shadow-lg w-100">
          <div class="modal-header border-0 bg-light pb-2">
            <h5 class="modal-title font-weight-bold text-dark">
              <i class="fas fa-history text-info me-2"></i> Record Update History: "{{ activeHistoryRecord?.title }}"
            </h5>
            <button type="button" class="btn-close text-dark" @click="showRecordHistoryModal = false"></button>
          </div>
          <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
            <div v-if="activeHistoryLogs.length === 0" class="text-center py-4 text-muted">
              <i class="fas fa-info-circle fa-2x mb-2 d-block"></i>
              No detailed modification history recorded yet for this item.
            </div>

            <div v-else class="timeline timeline-one-side">
              <div v-for="(log, idx) in activeHistoryLogs" :key="idx" class="timeline-block mb-3 border-bottom pb-3">
                <span class="timeline-step">
                  <i class="fas" :class="getActionIcon(log.action)"></i>
                </span>
                <div class="timeline-content">
                  <div class="d-flex justify-content-between align-items-center">
                    <h6 class="text-dark text-sm font-weight-bold mb-0">
                      {{ log.action }} by <span class="text-primary">{{ log.user_name || 'System' }}</span>
                    </h6>
                    <small class="text-muted text-xxs"><i class="fas fa-clock me-1"></i>{{ formatDate(log.updated_at) }}</small>
                  </div>

                  <!-- FIELD CHANGES BREAKDOWN TABLE -->
                  <div v-if="log.changes && Object.keys(log.changes).length > 0" class="mt-2 bg-light p-2 rounded">
                    <table class="table table-sm text-xxs mb-0">
                      <thead>
                        <tr>
                          <th>Field Changed</th>
                          <th>Old Value</th>
                          <th>New Value</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(val, field) in log.changes" :key="field">
                          <td class="font-weight-bold text-dark">{{ field }}</td>
                          <td class="text-danger text-truncate" style="max-width: 150px;">{{ formatValue(val.old) }}</td>
                          <td class="text-success text-truncate" style="max-width: 150px;">{{ formatValue(val.new) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer border-0">
            <button class="btn btn-secondary w-100" @click="showRecordHistoryModal = false">Close</button>
          </div>
        </div>
      </div>
    </div>

    <!-- EXISTING MODAL 1: ADD / EDIT TEMPLATE -->
    <div v-if="showModal" class="modal-overlay p-2 p-md-0">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content border-0 shadow-lg w-100">
          <div class="modal-header border-0 pb-0">
            <h5 class="modal-title font-weight-bold">{{ isEditing ? 'Edit Template' : 'Create Template' }}</h5>
            <button type="button" class="btn-close text-dark" @click="showModal = false"></button>
          </div>
          <div class="modal-body" style="max-height: 75vh; overflow-y: auto;">
            <div class="row">
              <div class="col-md-8 col-12">
                <div class="form-group mb-3">
                  <label class="form-label">Alert Title</label>
                  <input v-model="form.title" type="text" class="form-control" placeholder="e.g. Fire Alert">
                </div>
              </div>
              <div class="col-md-4 col-12">
                <div class="form-group mb-3">
                  <label class="form-label">Status</label>
                  <select v-model="form.status" class="form-select" @change="validationError = null">
                    <option value="inactive">Inactive</option>
                    <option value="active">Active (Show in Gallery)</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 col-12 mb-3">
                <label class="form-label font-weight-bold text-dark">Active From (Auto Live)</label>
                <input v-model="form.active_from" type="datetime-local" class="form-control">
                <small class="text-muted text-xxs">Automatically goes LIVE at this date & time.</small>
              </div>
              <div class="col-md-6 col-12 mb-3">
                <label class="form-label font-weight-bold text-dark">Active Till (Auto Remove)</label>
                <input v-model="form.active_to" type="datetime-local" class="form-control">
                <small class="text-muted text-xxs">Automatically removed from list when time is over.</small>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 col-12 mb-3">
                <label class="form-label">Step 1: Select Branches</label>
                <div class="border p-2 rounded bg-light" style="max-height: 150px; overflow-y: auto;">
                  <div class="form-check border-bottom pb-1 mb-2">
                    <input class="form-check-input" type="checkbox" v-model="selectAllBranches" id="selectAllBranches">
                    <label class="form-check-label text-sm font-weight-bold text-primary" for="selectAllBranches">Select All Branches</label>
                  </div>
                  <div v-for="branch in branches" :key="branch.id" class="form-check">
                    <input class="form-check-input" type="checkbox" :value="branch.id" v-model="form.branch_ids" @change="validationError = null" :id="'br-'+branch.id">
                    <label class="form-check-label text-sm" :for="'br-'+branch.id">{{ branch.branch_name }}</label>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-12 mb-3">
                <label class="form-label">Step 2: Specific Devices</label>
                <div class="border p-2 rounded bg-light" style="max-height: 150px; overflow-y: auto;">
                  <div class="form-check border-bottom pb-1 mb-2" v-if="filteredDevices.length > 0">
                    <input class="form-check-input" type="checkbox" v-model="selectAllDevices" id="selectAllDevices">
                    <label class="form-check-label text-sm font-weight-bold text-primary" for="selectAllDevices">Select All Devices</label>
                  </div>
                  <div v-for="dev in filteredDevices" :key="dev.id" class="form-check">
                    <input class="form-check-input" type="checkbox" :value="dev.id" v-model="form.device_ids" @change="validationError = null" :id="'dv-'+dev.id">
                    <label class="form-check-label text-sm" :for="'dv-'+dev.id">{{ dev.device_name }}</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group mb-3" v-if="form.type === 'playlist_link'">
              <label class="form-label text-primary font-weight-bold">Select Emergency Playlist</label>
              <select v-model="form.playlist_master_id" class="form-select border-primary" @change="onPlaylistChange(); validationError = null">
                <option :value="null">-- Choose Emergency Playlist --</option>
                <option v-for="pl in filteredEmergencyPlaylists" :key="pl.id" :value="pl.id">
                  {{ pl.playlist_name }}
                </option>
              </select>

              <div v-if="form.playlist_items && form.playlist_items.length > 0" class="mt-4">
                <p class="text-center font-weight-bold text-secondary mb-3">Selected Media</p>
                <div class="row g-3 justify-content-center">
                  <div v-for="(pItem, pIdx) in form.playlist_items" :key="pIdx" class="col-6 col-md-4">
                    <div class="card shadow-none border position-relative preview-thumb-container">
                      <div class="preview-media-box bg-dark rounded overflow-hidden">
                        <img v-if="pItem.type === 'image' || pItem.type === 1" 
                             :src="getFullUrl(pItem.media_url)" 
                             class="w-100 h-100 object-fit-cover">
                        <div v-else class="w-100 h-100 d-flex align-items-center justify-content-center text-white">
                          <i class="fas fa-video fa-2x"></i>
                        </div>
                        <div class="preview-badge">
                          {{ (pItem.type === 'image' || pItem.type === 1) ? 'Img' : 'Vid' }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <small class="text-muted d-block mt-2" v-if="form.playlist_items.length > 0">
                Detected {{ form.playlist_items.length }} media items.
              </small>
            </div>

            <div class="form-group mb-3">
              <label class="form-label">Display Message / Subtitle</label>
              <textarea v-model="form.message" class="form-control" rows="2" placeholder="Enter emergency text here..."></textarea>
            </div>
          </div>
          <div class="modal-footer border-0 d-flex flex-column align-items-end">
            <div v-if="validationError" class="text-danger text-sm mb-3 font-weight-bold w-100 text-end">
              <i class="fas fa-exclamation-circle me-1"></i> {{ validationError }}
            </div>
            <div class="d-flex w-100 justify-content-end gap-2">
              <button class="btn btn-link text-dark mb-0" @click="showModal = false">Cancel</button>
              <button class="btn bg-gradient-primary mb-0" @click="submitForm" :disabled="loading || !!validationError">
                {{ loading ? 'Saving...' : 'Save Template' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL 2: MEDIA GALLERY -->
    <div v-if="showMediaModal" class="modal-overlay p-2 p-md-0">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content border-0 shadow-lg w-100">
          <div class="modal-header border-0 pb-0">
            <h5 class="modal-title font-weight-bold">Emergency Media Gallery</h5>
            <button type="button" class="btn-close text-dark" @click="showMediaModal = false"></button>
          </div>
          <div class="modal-body bg-light" style="max-height: 70vh; overflow-y: auto;">
            <draggable v-model="draggableGallery" item-key="emergency_id" class="row px-2" handle=".drag-handle" ghost-class="ghost-gallery-card">
              <template #item="{element}">
                <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
                  <div class="card h-100 shadow-sm border-0 transition-hover"
                       :class="{ 'selected-card': isGallerySelected(element.emergency_id) }"
                       @click="toggleItemSelection(element.emergency_id)">
                    
                    <div class="selection-badge" v-if="isGallerySelected(element.emergency_id)">
                      <i class="fas fa-check-circle text-success"></i>
                    </div>

                    <div class="card-header p-2 bg-white border-bottom d-flex justify-content-between align-items-center">
                      <span class="drag-handle cursor-move text-secondary p-1" @click.stop title="Drag to reorder">
                        <i class="fas fa-arrows-alt"></i>
                      </span>
                      <span class="badge" :class="getTypeClass(element.type)">{{ element.type }}</span>
                    </div>
                    
                    <div class="position-relative bg-dark" style="height: 150px; overflow: hidden; display: flex; align-items: center; justify-content: center;">
                      <template v-if="element.media_url">
                        <img v-if="element.type === 'image'" :src="getFullUrl(element.media_url)" class="card-img-top rounded-0 h-100 w-100" style="object-fit: cover;">
                        <div v-else class="text-white text-center d-flex flex-column align-items-center">
                          <i class="fas fa-video fa-2x mb-1"></i>
                          <span class="text-xxs text-uppercase">Video File</span>
                        </div>
                      </template>

                      <template v-else-if="(element.type === 'playlist_link' || element.type === 'playlist') && ensureArray(element.playlist_items).length > 0">
                        <img v-if="ensureArray(element.playlist_items)[0].type === 'image' || ensureArray(element.playlist_items)[0].type === 1"
                             :src="getFullUrl(ensureArray(element.playlist_items)[0].media_url)" 
                             class="card-img-top rounded-0 h-100 w-100" style="object-fit: cover;">
                        <div v-else class="text-white text-center d-flex flex-column align-items-center">
                          <i class="fas fa-play-circle fa-2x mb-1"></i>
                          <span class="text-xxs text-uppercase">Playlist</span>
                        </div>
                      </template>

                      <div v-else class="text-white text-center"><i class="fas fa-file-alt fa-2x text-secondary"></i></div>

                      <div v-if="ensureArray(element.playlist_items).length > 1" class="position-absolute bottom-0 end-0 m-2 badge bg-dark opacity-8 shadow">
                        <i class="fas fa-images me-1"></i> {{ ensureArray(element.playlist_items).length }} FILES
                      </div>
                    </div>

                    <div class="card-body p-2 text-center bg-white">
                      <h6 class="text-sm mb-2 text-truncate">{{ element.title }}</h6>
                      <button class="btn btn-xs btn-outline-primary w-100 mb-2" @click.stop="openMultipleMedia(element)">
                         {{ (element.type === 'playlist_link' && ensureArray(element.playlist_items).length > 1) ? 'VIEW ALL' : 'VIEW' }}
                      </button>
                    </div>
                  </div>
                </div>
              </template>
            </draggable>
          </div>
          <div class="modal-footer flex-column flex-sm-row gap-2">
            <button class="btn btn-secondary mb-0 flex-grow-1" @click="showMediaModal = false">CANCEL</button>
            <button class="btn bg-gradient-success mb-0 flex-grow-1" @click="saveGallerySequence" :disabled="loadingSequence">
              {{ loadingSequence ? 'Saving...' : 'UPDATE GALLERY' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL 3: SELECTED MEDIA PREVIEW -->
    <div v-if="showSelectedModal" class="modal-overlay p-2 p-md-0">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content border-0 shadow-lg w-100">
          <div class="modal-header border-0">
            <h5 class="modal-title font-weight-bold">Selected Media Preview</h5>
            <button type="button" class="btn-close" @click="showSelectedModal = false"></button>
          </div>
          <div class="modal-body" style="max-height: 60vh; overflow-y: auto;">
            <div v-if="selectedVideosItems.length === 0" class="text-center py-4">
              <i class="fas fa-video-slash fa-3x text-secondary mb-3"></i>
              <p>No media selected in the Gallery yet.</p>
            </div>
            <div class="row" v-else>
              <div v-for="video in selectedVideosItems" :key="video.emergency_id" class="col-12 col-md-6 mb-3">
                <div class="card border shadow-none h-100">
                  <div class="card-body p-2 d-flex align-items-center">
                    <div class="bg-dark rounded me-3 d-flex align-items-center justify-content-center" style="width: 60px; height: 60px; flex-shrink: 0;">
                       <i :class="video.type === 'video' ? 'fas fa-play' : 'fas fa-image'" class="text-white"></i>
                    </div>
                    <div class="flex-grow-1 overflow-hidden">
                      <h6 class="text-sm mb-0 text-truncate">{{ video.title }}</h6>
                      <span class="text-xxs text-primary text-uppercase">{{ video.type }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer flex-column flex-sm-row gap-2">
            <button class="btn btn-secondary mb-0 flex-grow-1" @click="showSelectedModal = false">CLOSE</button>
            <button v-if="selectedVideosItems.length > 0" class="btn bg-gradient-success mb-0 flex-grow-1" @click="triggerGlobalEmergency">
                <i class="fas fa-play me-2"></i> START LOOP
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL 4: DEVICE DETAILS VIEW -->
    <div v-if="showDevicePlaylistModal" class="modal-overlay p-2 p-md-0">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content border-0 shadow-lg w-100">
          <div class="modal-header border-0 pb-0">
            <h5 class="modal-title font-weight-bold">Targeted Devices Status</h5>
            <button type="button" class="btn-close text-dark" @click="showDevicePlaylistModal = false"></button>
          </div>
          <div class="modal-body p-0">
            <div class="table-responsive">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Device Name</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Branch</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Active Playlist</th>
                   <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Control</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="loadingDevices">
                    <td colspan="4" class="text-center py-4">Loading device data...</td>
                  </tr>
                  
                  <tr v-for="dev in involvedDevices" :key="dev.id">
                    <td>
                      <div class="d-flex px-2 py-1 align-items-center">
                        <i class="fas fa-desktop me-3 text-primary d-none d-sm-inline"></i>
                        <h6 class="mb-0 text-sm">{{ dev.device_name }}</h6>
                      </div>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        {{ branches.find(b => b.id === dev.branch_id)?.branch_name || 'N/A' }}
                      </p>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0 text-primary">
                        {{ getPlaylistNameForDevice(dev) }}
                      </p>
                    </td>
                    <td class="text-center">
                      <div class="d-flex justify-content-center align-items-center gap-2">
                        <button v-if="isActuallyInEmergency(dev)" @click="clearDevice(dev.id)" class="btn btn-xs btn-outline-danger mb-0" title="Stop Emergency Mode">
                          STOP
                        </button>
                        <button @click="unassignPlaylist(dev.id)" class="btn btn-link text-danger mb-0 px-2" title="Unassign">
                          <i class="fas fa-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="involvedDevices.length === 0 && !loadingDevices">
                    <td colspan="4" class="text-center py-4 text-secondary">
                        No devices targeted.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary w-100" @click="showDevicePlaylistModal = false">Close</button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL 5: TRASH & AUDIT LOGS MODAL -->
    <div v-if="showTrashModal" class="modal-overlay p-2 p-md-0">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content border-0 shadow-lg w-100">
          <div class="modal-header border-0 pb-0">
            <h5 class="modal-title font-weight-bold text-danger">
              <i class="fas fa-history me-2"></i> Audit Trail & Trash History
            </h5>
            <button type="button" class="btn-close text-dark" @click="showTrashModal = false"></button>
          </div>
          <div class="modal-body p-0">
            <div class="table-responsive">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-4">Template Title</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Created By</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Updated By</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Stopped By</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Deleted By</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in trashedBroadcasts" :key="item.emergency_id">
                    <td class="ps-4">
                      <h6 class="mb-0 text-sm text-dark">{{ item.title }}</h6>
                      <span class="badge badge-sm" :class="getTypeClass(item.type)">{{ item.type }}</span>
                    </td>
                    <td class="text-xs">
                      <div><strong>{{ item.creator?.name || 'System' }}</strong></div>
                      <div class="text-muted">{{ formatDate(item.created_at) }}</div>
                    </td>
                    <td class="text-xs">
                      <div v-if="item.updater" class="text-info font-weight-bold">{{ item.updater?.name }}</div>
                      <div class="text-muted" v-if="item.updater">{{ formatDate(item.updated_at) }}</div>
                      <span v-else class="text-muted">N/A</span>
                    </td>
                    <td class="text-xs">
                      <div v-if="item.stopper" class="text-danger font-weight-bold">{{ item.stopper?.name }}</div>
                      <div class="text-muted" v-if="item.stopped_at">{{ formatDate(item.stopped_at) }}</div>
                      <span v-else class="text-muted">N/A</span>
                    </td>
                    <td class="text-xs">
                      <div class="text-danger font-weight-bold">
                        {{ item.deleter?.name || item.stopper?.name || item.updater?.name || item.creator?.name || 'System' }}
                      </div>
                      <div class="text-muted">{{ formatDate(item.deleted_at) }}</div>
                    </td>
                    <td class="text-center">
                      <button class="btn btn-xs btn-outline-success mb-0" @click="restoreTemplate(item)">
                        <i class="fas fa-undo me-1"></i> Restore
                      </button>
                    </td>
                  </tr>
                  <tr v-if="trashedBroadcasts.length === 0">
                    <td colspan="6" class="text-center py-4 text-secondary">No deleted or stopped audit records found.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary w-100" @click="showTrashModal = false">Close</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import draggable from "vuedraggable";
import Swal from 'sweetalert2';

export default {
  name: "EmergencyBroadcast",
  components: { draggable },
  data() {
    return {
      broadcasts: [],
      branches: [],
      devices: [],
      emergencyPlaylists: [], 
      allPlaylists: [], 
      trashedBroadcasts: [],
      showModal: false,
      showMediaModal: false,
      showSelectedModal: false,
      showDevicePlaylistModal: false,
      showTrashModal: false,
      showRecordHistoryModal: false,
      activeHistoryRecord: null,
      activeHistoryLogs: [],
      isEditing: false,
      editId: null,
      loading: false,
      loadingSequence: false, 
      loadingDevices: false, 
      draggableGallery: [], 
      selectedGalleryIds: [], 
      validationError: null, 
      currentPage: 1,
      itemsPerPage: 10,
      form: {
        title: "", type: "playlist_link", status: "inactive", message: "",
        file: null, branch_ids: [], device_ids: [], display_time: 10,
        playlist_items: [], playlist_master_id: null, mediaurl_playlist: [],
        active_from: null, active_to: null
      },
      apiUrl: process.env.VUE_APP_API_BASE_URL
    };
  },
  computed: {
    paginatedBroadcasts() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.broadcasts.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.broadcasts.length / this.itemsPerPage);
    },
    filteredEmergencyPlaylists() {
      const usedPlaylistIds = this.broadcasts
        .filter(item => {
          const isActive = item.status === 'active';
          const isNotTrashed = !item.deleted_at;
          const isNotCurrentRecord = this.isEditing ? item.emergency_id !== this.editId : true;
          return isActive && isNotTrashed && isNotCurrentRecord && item.playlist_master_id;
        })
        .map(item => String(item.playlist_master_id));

      return this.emergencyPlaylists.filter(pl => !usedPlaylistIds.includes(String(pl.id)));
    },
    involvedDevices() {
        if (this.broadcasts.length === 0) return [];
        return this.devices.filter(dev => {
            return this.broadcasts.some(template => {
                const tDevs = this.ensureArray(template.device_ids).map(id => String(id));
                const tBranches = this.ensureArray(template.branch_ids).map(id => String(id));
                const isGlobalTemplate = tDevs.length === 0 && tBranches.length === 0;
                return isGlobalTemplate || tDevs.includes(String(dev.id)) || tBranches.includes(String(dev.branch_id));
            });
        });
    },
    filteredDevices() {
      if (this.form.branch_ids && this.form.branch_ids.length > 0) {
        return this.devices.filter(dev => this.form.branch_ids.includes(dev.branch_id));
      }
      return this.devices;
    },
    mediaItems() { return this.broadcasts; },
    selectedVideosItems() { return this.broadcasts.filter(item => this.selectedGalleryIds.includes(item.emergency_id)); },
    selectedVideosCount() { return this.selectedVideosItems.length; },
    isGlobalLive() { return this.broadcasts.some(item => item.is_live); },
    selectAllBranches: {
      get() { return this.branches.length > 0 && this.form.branch_ids.length === this.branches.length; },
      set(value) { 
          this.form.branch_ids = value ? this.branches.map(b => b.id) : []; 
          this.validationError = null; 
      }
    },
    selectAllDevices: {
      get() {
        if (this.filteredDevices.length === 0) return false;
        return this.filteredDevices.every(dev => this.form.device_ids.includes(dev.id));
      },
      set(value) {
        const filteredIds = this.filteredDevices.map(d => d.id);
        if (value) {
          this.form.device_ids = [...new Set([...this.form.device_ids, ...filteredIds])];
        } else {
          this.form.device_ids = this.form.device_ids.filter(id => !filteredIds.includes(id));
        }
        this.validationError = null; 
      }
    }
  },
  methods: {
    openHistoryModal(item) {
      this.activeHistoryRecord = item;
      this.activeHistoryLogs = this.ensureArray(item.update_history).slice(0, 5);
      this.showRecordHistoryModal = true;
    },
    getActionIcon(action) {
      if (action === 'CREATED') return 'fa-plus text-success';
      if (action === 'UPDATED') return 'fa-edit text-info';
      if (action === 'STOPPED') return 'fa-stop-circle text-danger';
      if (action === 'TRIGGERED_LIVE') return 'fa-bolt text-warning';
      if (action === 'RESTORED') return 'fa-undo text-primary';
      return 'fa-history text-secondary';
    },
    formatValue(val) {
      if (val === null || val === undefined) return 'None';
      if (typeof val === 'object') return JSON.stringify(val);
      return String(val);
    },
    formatDatetimeLocal(dateStr) {
      if (!dateStr) return null;
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return null;
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return dateStr;
      return d.toLocaleString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    isOrphaned(item) {
        return (item.type === 'playlist_link' || item.type === 'playlist') && !item.playlist_master_id;
    },
    getActiveTemplate(dev) {
        return this.broadcasts.find(template => {
            if (!template.is_live) return false;
            const targetDevices = this.ensureArray(template.device_ids).map(id => String(id));
            const targetBranches = this.ensureArray(template.branch_ids).map(id => String(id));
            const isGlobal = targetDevices.length === 0 && targetBranches.length === 0;
            return isGlobal || targetDevices.includes(String(dev.id)) || targetBranches.includes(String(dev.branch_id));
        });
    },
    getPlaylistNameForDevice(dev) {
        const activeLiveTemplate = this.getActiveTemplate(dev);
        if (activeLiveTemplate && activeLiveTemplate.playlist_master_id) {
            const pl = this.allPlaylists.find(p => String(p.id) === String(activeLiveTemplate.playlist_master_id));
            if (pl) return pl.playlist_name;
        }

        const targetedTemplate = this.broadcasts.find(template => {
            const targetDevices = this.ensureArray(template.device_ids).map(id => String(id));
            const targetBranches = this.ensureArray(template.branch_ids).map(id => String(id));
            const isGlobal = targetDevices.length === 0 && targetBranches.length === 0;
            return (isGlobal || targetDevices.includes(String(dev.id)) || targetBranches.includes(String(dev.branch_id))) && template.playlist_master_id;
        });

        if (targetedTemplate) {
            const pl = this.allPlaylists.find(p => String(p.id) === String(targetedTemplate.playlist_master_id));
            if (pl) return pl.playlist_name;
        }

        const normalPl = this.allPlaylists.find(pl => String(pl.id) === String(dev.playlist_master_id));
        return normalPl ? normalPl.playlist_name : 'No Playlist Assigned';
    },
    isActuallyInEmergency(dev) {
        return dev.is_emergency || !!this.getActiveTemplate(dev);
    },
    getActiveTemplateTitle(dev) {
        const template = this.getActiveTemplate(dev);
        return template ? template.title : 'Global Loop';
    },
    openDevicePlaylistModal() { this.showDevicePlaylistModal = true; },
    getAuthHeader(isFormData = false) {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      if (!isFormData) headers['Content-Type'] = 'application/json';
      return { headers };
    },
    getFullUrl(path) {
        if (!path) return "";
        if (path.startsWith('http://') || path.startsWith('https://')) return path;
        const baseUrl = this.apiUrl.replace('/v1/admin', '');
        const cleanPath = path.replace(/\\/g, '/');
        const formattedPath = cleanPath.startsWith('/') ? cleanPath : `/${cleanPath}`;
        return `${baseUrl}${formattedPath}`;
    },
    ensureArray(data) {
      if (!data) return [];
      if (Array.isArray(data)) return data;
      try { return JSON.parse(data) || []; } catch (e) { return []; }
    },
    getMappedNames(idArray, masterList, nameField) {
      const ids = this.ensureArray(idArray);
      if (ids.length === 0) return "None / All";
      const names = masterList.filter(item => ids.includes(item.id)).map(item => item[nameField]);
      return names.length > 0 ? names.join(", ") : "All Devices";
    },
    async fetchData() {
      try {
        const header = this.getAuthHeader();
        const [resB, resBr, resDv, resPl] = await Promise.all([
          axios.get(`${this.apiUrl}/v1/admin/emergency/list`, header),
          axios.get(`${this.apiUrl}/v1/admin/branches`, header),
          axios.get(`${this.apiUrl}/v1/admin/user-device-list`, header),
          axios.get(`${this.apiUrl}/v1/admin/playlist/list`, header)
        ]);
        this.broadcasts = resB.data.data || [];
        this.selectedGalleryIds = this.broadcasts.filter(item => item.is_selected).map(item => item.emergency_id);
        this.branches = resBr.data || [];
        this.devices = resDv.data.data || resDv.data || [];
        const allPls = Array.isArray(resPl.data) ? resPl.data : (resPl.data.data || []);
        this.allPlaylists = allPls; 
        this.emergencyPlaylists = allPls.filter(p => p.is_emergency_broadcast == 1);
      } catch (e) { console.error("Error fetching data:", e); }
    },
    async openTrashModal() {
      try {
        const res = await axios.get(`${this.apiUrl}/v1/admin/emergency/trash-list`, this.getAuthHeader());
        this.trashedBroadcasts = res.data.data || [];
        this.showTrashModal = true;
      } catch (e) {
        Swal.fire({ icon: 'error', text: 'Failed to fetch audit trash history' });
      }
    },
    async restoreTemplate(item) {
      const emergencyId = typeof item === 'object' ? item.emergency_id : item;
      const currentItem = typeof item === 'object' ? item : this.trashedBroadcasts.find(t => t.emergency_id === emergencyId);

      const defaultFrom = currentItem?.active_from ? this.formatDatetimeLocal(currentItem.active_from) : '';
      const defaultTo = currentItem?.active_to ? this.formatDatetimeLocal(currentItem.active_to) : '';

      Swal.fire({
        title: 'Restore Template',
        text: 'Set active duration for this restored template',
        html: `
          <div class="text-start mb-3">
            <label class="form-label font-weight-bold text-xs text-dark mb-1">Active From (Auto Live)</label>
            <input type="datetime-local" id="restore-active-from" class="form-control form-control-sm" value="${defaultFrom}">
            <small class="text-muted text-xxs d-block mt-1">Automatically goes LIVE at this date & time.</small>
          </div>
          <div class="text-start">
            <label class="form-label font-weight-bold text-xs text-dark mb-1">Active Till (Auto Remove)</label>
            <input type="datetime-local" id="restore-active-to" class="form-control form-control-sm" value="${defaultTo}">
            <small class="text-muted text-xxs d-block mt-1">Automatically removed when time is over.</small>
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: '<i class="fas fa-undo me-1"></i> Restore Now',
        confirmButtonColor: '#2dce89',
        cancelButtonText: 'Cancel',
        focusConfirm: false,
        preConfirm: () => {
          const active_from = document.getElementById('restore-active-from').value;
          const active_to = document.getElementById('restore-active-to').value;
          
          if (active_from && active_to && new Date(active_from) >= new Date(active_to)) {
            Swal.showValidationMessage('"Active From" date must be earlier than "Active Till" date.');
            return false;
          }
          return { active_from: active_from || null, active_to: active_to || null };
        }
      }).then(async (result) => {
        if (result.isConfirmed && result.value) {
          try {
            const res = await axios.post(`${this.apiUrl}/v1/admin/emergency/restore/${emergencyId}`, result.value, this.getAuthHeader());
            if (res.data.success) {
              Swal.fire({ icon: 'success', title: 'Restored', text: 'Template restored successfully' });
              await this.fetchData();
              await this.openTrashModal();
            }
          } catch (e) {
            Swal.fire({ icon: 'error', text: 'Failed to restore template: ' + (e.response?.data?.message || e.message) });
          }
        }
      });
    },

    onFileChange(e) { this.form.file = e.target.files[0]; },
    isGallerySelected(id) { return this.selectedGalleryIds.includes(id); },
    async toggleItemSelection(id) {
        const idx = this.selectedGalleryIds.indexOf(id);
        if (idx === -1) this.selectedGalleryIds.push(id);
        else this.selectedGalleryIds.splice(idx, 1);
        try {
            await axios.put(`${this.apiUrl}/v1/admin/emergency/update-selection`, { selectedIds: this.selectedGalleryIds }, this.getAuthHeader());
        } catch (e) { console.error("Selection sync failed", e); }
    },
    openAddModal() {
      this.isEditing = false;
      this.validationError = null; 
      this.form = { title: "", type: "playlist_link", status: "inactive", message: "", file: null, branch_ids: [], device_ids: [], display_time: 10, playlist_items: [], playlist_master_id: null, mediaurl_playlist: [], active_from: null, active_to: null };
      this.showModal = true;
    },
    openEditModal(item) {
      this.isEditing = true;
      this.editId = item.emergency_id; 
      this.validationError = null; 
      this.form = { 
          ...item, 
          branch_ids: this.ensureArray(item.branch_ids), 
          device_ids: this.ensureArray(item.device_ids), 
          playlist_items: this.ensureArray(item.playlist_items), 
          active_from: this.formatDatetimeLocal(item.active_from),
          active_to: this.formatDatetimeLocal(item.active_to),
          file: null 
      };
      this.showModal = true;
    },
    openMediaGallery() {
      this.draggableGallery = JSON.parse(JSON.stringify(this.mediaItems));
      this.showMediaModal = true;
    },
    async saveGallerySequence() {
      this.loadingSequence = true;
      try {
        const sequenceData = this.draggableGallery.map((item, index) => ({ emergency_id: item.emergency_id, sequence: index }));
        await axios.put(`${this.apiUrl}/v1/admin/emergency/update-sequence`, { sequenceData }, this.getAuthHeader());
        await axios.put(`${this.apiUrl}/v1/admin/emergency/update-selection`, { selectedIds: this.selectedGalleryIds }, this.getAuthHeader());
        await this.fetchData();
        this.showMediaModal = false;
        Swal.fire({ icon: 'success', title: 'Success', text: 'Gallery sequence updated' });
      } catch (error) { 
          Swal.fire({ icon: 'error', title: 'Oops...', text: "Failed to update sequence." });
      } finally { this.loadingSequence = false; }
    },
    async onPlaylistChange() {
      if (!this.form.playlist_master_id) {
        this.form.playlist_items = [];
        this.form.mediaurl_playlist = []; 
        return;
      }
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${this.apiUrl}/v1/admin/playlist-master/edit/${this.form.playlist_master_id}`, { headers: { Authorization: `Bearer ${token}` } });
        if (response.data && response.data.playlist && response.data.playlist.playlistDetails) { 
          const details = response.data.playlist.playlistDetails;
          this.form.playlist_items = details.map(item => ({ media_id: item.media_id, media_url: item.media_url, type: item.type }));
          this.form.mediaurl_playlist = details.map(item => item.media_url);
        }
      } catch (error) { console.error("Error fetching playlist items:", error); }
    },
    async stopSingleEmergency(item) {
        Swal.fire({
          title: 'Confirm Stop',
          text: `Stop broadcasting "${item.title}"?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, stop it!',
          cancelButtonText: 'Cancel'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await axios.post(`${this.apiUrl}/v1/admin/emergency/stop`, { emergency_id: item.emergency_id, branch_ids: this.ensureArray(item.branch_ids), device_ids: this.ensureArray(item.device_ids) }, this.getAuthHeader());
                    if (res.data.success) { 
                        await this.fetchData(); 
                        Swal.fire({ icon: 'success', title: 'Success', text: 'Broadcast stopped.' });
                    }
                } catch (e) { 
                    Swal.fire({ icon: 'error', title: 'Error', text: "Stop failed: " + (e.response?.data?.message || e.message) });
                }
            }
        });
    },
    async triggerSingleEmergency(item) {
        Swal.fire({
          title: 'Confirm Broadcast',
          text: `Broadcasting "${item.title}" will override current loops. Start now?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, Start!',
          cancelButtonText: 'Cancel'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await axios.post(`${this.apiUrl}/v1/admin/emergency/trigger`, { emergency_id: item.emergency_id, branch_ids: [], device_ids: [] }, this.getAuthHeader());
                    if (res.data.success) { 
                        await this.fetchData(); 
                        Swal.fire({ icon: 'success', title: 'Success', text: 'Broadcast started' });
                    }
                } catch (e) { 
                    Swal.fire({ icon: 'error', title: 'Error', text: "Trigger failed: " + (e.response?.data?.message || e.message) });
                }
            }
        });
    },
    async triggerGlobalEmergency() {
      try {
        const res = await axios.post(`${this.apiUrl}/v1/admin/emergency/trigger-global`, { branch_ids: [], device_ids: [] }, this.getAuthHeader());
        if (res.data.success) { 
            await this.fetchData(); 
            this.showSelectedModal = false; 
            Swal.fire({ icon: 'success', title: 'Success', text: 'Global loop started' });
        }
      } catch (e) { 
          Swal.fire({ icon: 'error', title: 'Error', text: "Trigger failed: " + (e.response?.data?.message || e.message) });
      }
    },
    async stopAllEmergency() {
      Swal.fire({
        title: 'Stop All Broadcasts?',
        text: "Stop all active emergency broadcasts?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Yes, Stop All',
        cancelButtonText: 'Cancel'
      }).then(async (result) => {
          if (result.isConfirmed) {
              try {
                const res = await axios.post(`${this.apiUrl}/v1/admin/emergency/stop`, { branch_ids: [], device_ids: [] }, this.getAuthHeader());
                if (res.data.success) { 
                    await this.fetchData(); 
                    Swal.fire({ icon: 'success', title: 'Success', text: 'All broadcasts stopped.' });
                }
              } catch (e) { 
                  Swal.fire({ icon: 'error', title: 'Error', text: "Error stopping" });
              }
          }
      });
    },
    async submitForm() {
      if (!this.form.title) return Swal.fire({ icon: 'info', text: "Please enter a title" });
      if (this.form.type === 'playlist_link' && !this.form.playlist_master_id) return Swal.fire({ icon: 'info', text: "Please select an Emergency Playlist" });
      if (this.form.status === 'active' && this.form.branch_ids.length === 0 && this.form.device_ids.length === 0) return Swal.fire({ icon: 'info', text: "To set a template as 'Active', you must select at least one Branch or Device." });
      
      this.loading = true;
      this.validationError = null; 
      
      const formData = new FormData();
      formData.append('title', this.form.title || '');
      formData.append('type', this.form.type || '');
      formData.append('status', this.form.status || 'inactive');
      formData.append('message', this.form.message || '');
      formData.append('display_time', this.form.display_time || 10);
      formData.append('active_from', this.form.active_from || '');
      formData.append('active_to', this.form.active_to || '');
      
      if (this.form.playlist_master_id) {
        formData.append('playlist_master_id', this.form.playlist_master_id);
      }
      
      if (this.form.file && this.form.file instanceof File) {
        formData.append('file', this.form.file);
      }
      
      formData.append('branch_ids', JSON.stringify(this.form.branch_ids || []));
      formData.append('device_ids', JSON.stringify(this.form.device_ids || []));
      formData.append('playlist_items', JSON.stringify(this.form.playlist_items || []));
      formData.append('mediaurl_playlist', JSON.stringify(this.form.mediaurl_playlist || []));

      try {
        const url = this.isEditing ? `${this.apiUrl}/v1/admin/emergency/update/${this.editId}` : `${this.apiUrl}/v1/admin/emergency/add`;
        const res = await axios[this.isEditing ? 'put' : 'post'](url, formData, this.getAuthHeader(true));
        
        if (res.data.success) { 
          this.showModal = false; 
          await this.fetchData(); 
          Swal.fire({ icon: 'success', title: 'Success', text: this.isEditing ? 'Template updated successfully' : 'Template created successfully' });
        }
      } catch (e) { 
        this.validationError = e.response?.data?.message || e.message; 
      } finally { 
        this.loading = false; 
      }
    },
    async deleteTemplate(id) {
      Swal.fire({
        title: 'Move to Trash?',
        text: "Template will be archived in Audit Trash history.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Yes, Move to Trash',
        cancelButtonText: 'Cancel'
      }).then(async (result) => {
          if (result.isConfirmed) {
              try { 
                await axios.delete(`${this.apiUrl}/v1/admin/emergency/delete/${id}`, this.getAuthHeader()); 
                await this.fetchData(); 
                Swal.fire({ icon: 'success', title: 'Success', text: 'Template moved to trash' });
              } catch (e) { 
                Swal.fire({ icon: 'error', title: 'Error', text: "Delete failed" });
              }
          }
      });
    },
    getTypeClass(type) {
      const colors = { text: 'bg-gradient-info', image: 'bg-gradient-warning', video: 'bg-gradient-primary', playlist: 'bg-gradient-success', playlist_link: 'bg-gradient-dark' };
      return colors[type] || 'bg-gradient-secondary';
    },
    viewMedia(path) { 
        if(!path) return Swal.fire({ icon: 'info', text: "No media preview available" });
        window.open(this.getFullUrl(path), '_blank'); 
    },
    openMultipleMedia(element) {
        const items = this.ensureArray(element.playlist_items);
        if (items.length > 0) {
            items.forEach((item, index) => {
                setTimeout(() => {
                    const url = this.getFullUrl(item.media_url);
                    if (url) window.open(url, '_blank');
                }, index * 600); 
            });
        } else if (element.media_url) window.open(this.getFullUrl(element.media_url), '_blank');
        else Swal.fire({ icon: 'info', text: "No media preview available" });
    },
    async clearDevice(deviceId) {
      Swal.fire({
        title: 'Stop Emergency?',
        text: "Stop emergency broadcast on this device?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Stop',
        cancelButtonText: 'Cancel'
      }).then(async (result) => {
          if (result.isConfirmed) {
              try {
                const res = await axios.post(`${this.apiUrl}/v1/admin/emergency/device-clear`, { device_id: deviceId }, this.getAuthHeader());
                if (res.data.success) { 
                    await this.fetchData(); 
                    Swal.fire({ icon: 'success', title: 'Success', text: "Emergency stopped on device" });
                }
              } catch (e) { 
                  Swal.fire({ icon: 'error', title: 'Error', text: "Operation failed: " + (e.response?.data?.message || e.message) });
              }
          }
      });
    },
    async unassignPlaylist(deviceId) {
      Swal.fire({
          title: 'Action Required',
          text: "Delete associated emergency template from library entirely? \n\nClick OK to DELETE RECORD. \nClick CANCEL to keep record as UNASSIGNED (RED).",
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'OK (DELETE RECORD)',
          cancelButtonText: 'CANCEL (KEEP UNASSIGNED)',
          reverseButtons: false
      }).then(async (result) => {
          const shouldDeleteRecord = result.isConfirmed;

          try {
              const res = await axios.post(`${this.apiUrl}/v1/admin/emergency/device-unassign-playlist`, {
                  device_id: deviceId,
                  deleteRecord: shouldDeleteRecord
              }, this.getAuthHeader());
              
              if (res.data.success) {
                  await this.fetchData(); 
                  Swal.fire({ icon: 'success', title: 'Success', text: "Playlist removed successfully" });
              }
          } catch (e) {
              Swal.fire({ icon: 'error', title: 'Error', text: "Error: " + (e.response?.data?.message || e.message) });
          }
      });
    }
  },
  mounted() { this.fetchData(); }
};
</script>

<style scoped>
.modal-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); display: flex; justify-content: center; align-items: center; z-index: 1060; }
.modal-dialog { width: 95%; max-width: 700px; }
.modal-xl { max-width: 1140px; }
.selected-card { border: 3px solid #5e72e4 !important; transform: translateY(-5px); }
.selection-badge { position: absolute; top: -8px; right: -8px; background: white; border-radius: 50%; color: #2dce89; font-size: 22px; z-index: 10; line-height: 1; }
.cursor-move { cursor: grab; }
.pulse-red-small { animation: pulse-animation 1.5s infinite; }
@keyframes pulse-animation { 0% { box-shadow: 0 0 0 0px rgba(255, 82, 82, 0.7); } 100% { box-shadow: 0 0 0 10px rgba(255, 82, 82, 0); } }
.bg-light-danger { background-color: rgba(255, 0, 0, 0.04) !important; }
.preview-thumb-container { border-radius: 12px !important; overflow: hidden; border: 1px solid #e9ecef; background: #fff; padding: 0; }
.preview-media-box { height: 120px; position: relative; }
.object-fit-cover { object-fit: cover; }
.preview-badge { position: absolute; bottom: 8px; left: 8px; background: #007bff; color: white; padding: 2px 10px; border-radius: 4px; font-size: 11px; font-weight: bold; }
.row.g-3 { margin-top: 10px; }

.border-orphaned {
  border: 2px solid #ff0000 !important;
  background-color: rgba(255, 0, 0, 0.08) !important;
}

.pagination.pagination-primary .page-item.active .page-link {
  background-color: #5e72e4;
  border-color: #5e72e4;
  color: #fff;
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}
.pagination .page-link {
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8898aa;
  padding: 0;
  margin: 0 3px;
  border-radius: 50% !important;
  width: 36px;
  height: 36px;
  transition: all 0.3s ease;
}
.pagination .page-link:hover {
  background-color: #eee;
}

/* TIMELINE STYLES FOR HISTORY LOGS */
.timeline-block { display: flex; align-items: flex-start; }
.timeline-step { width: 32px; height: 32px; border-radius: 50%; background: #f6f9fc; display: flex; align-items: center; justify-content: center; margin-right: 15px; flex-shrink: 0; }
.timeline-content { flex-grow: 1; }

@media (max-width: 768px) {
  .card-header { padding-bottom: 20px !important; }
  .btn-sm { font-size: 11px; padding: 8px 12px; }
  .modal-dialog { margin: 0.5rem; }
}
</style>